<!-- only_desktop -->
<section class="cookies d-none d-md-block">
    <div class="d-flex jc-space-between" style="padding-top: 0.2rem;">
        <p class="modaltitle" [style.color]="themedata.color">About Cookies on this site
        <p>
            <span class="ms-3 d-flex cursor-pointer jc-center border rounded-circle bg-light align-items-center"
                [style.color]="themedata.color" (click)="onClose()">
                <mat-icon class="text-dark fs-6 fw-bold text-center" style="padding-top: 0.28rem;">close</mat-icon>
            </span>
    </div>
    <mat-dialog-content class="">
        <div class="d-flex">
            <div>
                <!-- <p class="modaldesc" [style.color]="themedata.color"
                    [innerHTML]="cookieConsentDescription | highlight : themedata.primarytheme">
                </p> -->
                <p class="modaldesc" [style.color]="themedata.color"
                    [innerHTML]="cookieConsentData?.descriptionOne | highlight : themedata.primarytheme"></p>

                <p class="modaldesc" [style.color]="themedata.color"
                    [innerHTML]="cookieConsentData?.descriptionTwo | highlight : themedata.primarytheme"></p>

                <p class="modaldesc" [style.color]="themedata.color"
                    [innerHTML]="cookieConsentData?.descriptionThree | highlight : themedata.primarytheme"></p>

                <p class="modaldesc" [style.color]="themedata.color"
                    [innerHTML]="cookieConsentData?.descriptionFour | highlight : themedata.primarytheme"></p>

                <p class="modaldesc" [style.color]="themedata.color">
                    If you have any questions regarding our cookie or cookie policy, please submit details in our
                    request
                    form
                    <a [style.color]="themedata.primarytheme" class="text-underline" (click)="openHelpPage()">
                        here.
                    </a>
                </p>

                <div class="d-flex jc-start mt-1">
                    <button class="modalbutton text-center me-2"
                        style="border: 0.1rem solid; background-color: #558dca;" (click)="allowAllCookies()" autofocus
                        [style.border-color]="themedata.secondarygradient1" [style.color]="themedata.cardbg">
                        Allow All Cookies
                    </button>
                    <button class="modalbutton text-center me-2"
                        style="border: 0.1rem solid; background-color: #558dca;" (click)="allowSelectedCookies()"
                        autofocus [style.border-color]="themedata.secondarygradient1" [style.color]="themedata.cardbg">
                        Allow Selected Cookies
                    </button>
                    <button class="modalbutton text-center" style="border: 0.1rem solid; background-color: #558dca;"
                        (click)="denyAllCookies()" [style.border-color]="themedata.secondarygradient1"
                        [style.color]="themedata.cardbg">
                        Deny All
                    </button>
                </div>
            </div>
            <mat-divider vertical style="height:auto" class="mx-2"></mat-divider>
            <div class="">
                <div class="d-flex jc-left">
                    <mat-slide-toggle class="" [color]="'primary'" [disabled]="true"
                        [(ngModel)]="isNecessaryCookiesAllowed"></mat-slide-toggle>
                    <div class="ml-1">
                        <p class="toggellabel" [style.color]="themedata.color">Necessary Cookies</p>
                        <p class="toggledesc" [style.color]="themedata.color">
                            Also referred to as essential cookies or strictly necessary cookies, are needed for
                            functioning of a website or web-application which may include navigation, access to secure
                            areas of website and user authentication.
                        </p>
                    </div>
                </div>
                <div class="d-flex jc-left">
                    <mat-slide-toggle class="" [color]="'primary'"
                        [(ngModel)]="isPreferencedCookiesAllowed"></mat-slide-toggle>
                    <div class="ml-1">
                        <p class="toggellabel" [style.color]="themedata.color">Performance Cookies</p>
                        <p class="toggledesc" [style.color]="themedata.color">
                            Performance cookies are typically used by website owners and developers to optimize the
                            design and content of the site, identify and fix usability issues, and measure the
                            effectiveness of marketing campaigns. By analysing the data collected by performance
                            cookies, we can make informed decisions about how to enhance the user experience and drive
                            engagement. These cookies don't collect information that identifies a visitor.
                        </p>
                    </div>
                </div>
                <div class="d-flex jc-left">
                    <mat-slide-toggle class="" [color]="'primary'"
                        [(ngModel)]="isMarketingCookiesAllowed"></mat-slide-toggle>
                    <div class="ml-1">
                        <p class="toggellabel" [style.color]="themedata.color">Marketing Cookies</p>
                        <p class="toggledesc" [style.color]="themedata.color">
                            Marketing cookies are used to track visitors across websites to allow publishers to display
                            relevant and engaging advertisements.
                        </p>
                    </div>
                </div>
                <div class="d-flex jc-left">
                    <mat-slide-toggle class="" [color]="'primary'"
                        [(ngModel)]="isAnalyticalCookiesAllowed"></mat-slide-toggle>
                    <div class="ml-1">
                        <p class="toggellabel" [style.color]="themedata.color">Analytical Cookies</p>
                        <p class="toggledesc" [style.color]="themedata.color">
                            First-party analytics cookies are a type of cookie that collects data about how users
                            interact with our website. These cookies are used to analyse and measure various aspects of
                            website performance, such as the number of visitors, pages visited, time spent on each page,
                            and user engagement. These cookies do not gather data that can pinpoint a visitor's identity
                            at an individual level, as such information is not accessible to us. Additionally, these
                            cookies do not transmit personally identifiable information to any external third party,
                            except in specific instances where we enlist a service provider to assist us, under strict
                            conditions where they are unable to utilize the data for their own purposes.
                        </p>
                    </div>
                </div>
                <div class="d-flex jc-left">
                    <mat-slide-toggle class="" [color]="'primary'"
                        [(ngModel)]="isOtherCookiesAllowed"></mat-slide-toggle>
                    <div class="ml-1">
                        <p class="toggellabel" [style.color]="themedata.color">Functional Cookies</p>
                        <p class="toggledesc" [style.color]="themedata.color">
                            These cookies are used to enhance functionality and usability of the website for the users
                            and are considered essential for providing specific features and services requested by the
                            users. For example, functional cookies may remember a user's language preference, font size
                            selection, or region-specific settings, ensuring that the website is displayed according to
                            the user's preferences each time they visit. These cookies do not have the capability to
                            monitor your browsing activity on external websites. They do not collect any data about you
                            that could be utilized for advertising purposes or to recall your internet browsing history
                            beyond our website.
                        </p>
                    </div>
                </div>
            </div>

        </div>


        <!-- <mat-divider></mat-divider> -->
    </mat-dialog-content>
    <div class="d-flex jc-right">
        <button class="modalbutton text-center" style="border: 0.1rem solid; background-color: #558dca;"
            (click)="saveCookieConsent()" [style.border-color]="themedata.secondarygradient1"
            [style.color]="themedata.cardbg">
            Save Settings
        </button>
    </div>
</section>

<!-- only_mobile -->
<section class="cookies_mobile col-sm-12 d-md-none d-lg-none" [style.background-color]="themedata.cardbg">

    <div class="d-flex jc-space-between" style="height: 5vh;">
        <p class="modaltitle" [style.color]="themedata.color">About Cookies on this site</p>
        <span class="ms-3 d-flex cursor-pointer jc-center border rounded-circle bg-light align-items-center"
            [style.color]="themedata.color" (click)="onClose()">
            <mat-icon class="text-dark fs-6 fw-bold text-center" style="padding-top: 0.28rem;">close</mat-icon>
        </span>
    </div>
    <mat-dialog-content>
        <div class="col-sm-12 justify-content-center">

            <!-- <p class="toggledesc {{fontData.name}}" [style.color]="themedata.color"
                [innerHTML]="cookieConsentDescription | highlight : themedata.primarytheme">
            </p> -->
            <p class="toggledesc" [style.color]="themedata.color"
                [innerHTML]="cookieConsentData?.descriptionOne | highlight : themedata.primarytheme"></p>

            <p class="toggledesc" [style.color]="themedata.color"
                [innerHTML]="cookieConsentData?.descriptionTwo | highlight : themedata.primarytheme"></p>

            <p class="toggledesc" [style.color]="themedata.color"
                [innerHTML]="cookieConsentData?.descriptionThree | highlight : themedata.primarytheme"></p>

            <p class="toggledesc" [style.color]="themedata.color"
                [innerHTML]="cookieConsentData?.descriptionFour | highlight : themedata.primarytheme"></p>

            <p class="toggledesc {{fontData.name}}" [style.color]="themedata.color">
                If you have any questions regarding our cookie or cookie policy, please submit details in our request
                form
                <a [style.color]="themedata.primarytheme" class="text-underline" (click)="openHelpPage()">
                    here.
                </a>
            </p>
            <div class="jc-center d-flex text-start">
                <button class="modalbutton me-2 {{fontData.name}}" (click)="allowAllCookies()" autofocus
                    [style.background-color]="themedata.primarytheme" [style.border-color]="themedata.primarytheme"
                    [style.color]="themedata.cardtext">
                    Allow All Cookies
                </button>
                <button class="modalbutton me-2 {{fontData.name}}" (click)="allowSelectedCookies()" autofocus
                    [style.background-color]="themedata.primarytheme" [style.border-color]="themedata.primarytheme"
                    [style.color]="themedata.cardtext">
                    Allow Selected Cookies
                </button>
                <button class="modalbutton {{fontData.name}}" (click)="denyAllCookies()"
                    [style.background-color]="themedata.primarytheme" [style.border-color]="themedata.primarytheme"
                    [style.color]="themedata.cardtext">
                    Deny All
                </button>
            </div>

            <mat-divider class="my-2"></mat-divider>

            <div class="">
                <div class="d-flex jc-left">
                    <mat-slide-toggle class="" [color]="'primary'" [disabled]="true"
                        [(ngModel)]="isNecessaryCookiesAllowed"></mat-slide-toggle>
                    <div class="ml-1">
                        <h3 class="toggellabel" [style.color]="themedata.color">Necessary Cookies</h3>
                        <p class="toggledesc {{fontData.name}}" [style.color]="themedata.color">
                            Also referred to as essential cookies or strictly necessary cookies, are needed for
                            functioning of a website or web-application which may include navigation, access to secure
                            areas of website and user authentication.
                        </p>
                    </div>
                </div>
                <div class="d-flex jc-left">
                    <mat-slide-toggle class="" [color]="'primary'"
                        [(ngModel)]="isPreferencedCookiesAllowed"></mat-slide-toggle>
                    <div class="ml-1">
                        <h3 class="toggellabel" [style.color]="themedata.color">Performance Cookies</h3>
                        <p class="toggledesc {{fontData.name}}" [style.color]="themedata.color">
                            Performance cookies are typically used by website owners and developers to optimize the
                            design and content of the site, identify and fix usability issues, and measure the
                            effectiveness of marketing campaigns. By analysing the data collected by performance
                            cookies, we can make informed decisions about how to enhance the user experience and drive
                            engagement. These cookies don't collect information that identifies a visitor.
                        </p>
                    </div>
                </div>
                <div class="d-flex jc-left">
                    <mat-slide-toggle class="" [color]="'primary'"
                        [(ngModel)]="isMarketingCookiesAllowed"></mat-slide-toggle>
                    <div class="ml-1">
                        <h3 class="toggellabel" [style.color]="themedata.color">Marketing Cookies</h3>
                        <p class="toggledesc {{fontData.name}}" [style.color]="themedata.color">
                            Marketing cookies are used to track visitors across websites to allow publishers to display
                            relevant and engaging advertisements.
                        </p>
                    </div>
                </div>
                <div class="d-flex jc-left">
                    <mat-slide-toggle class="" [color]="'primary'"
                        [(ngModel)]="isAnalyticalCookiesAllowed"></mat-slide-toggle>
                    <div class="ml-1">
                        <h3 class="toggellabel" [style.color]="themedata.color">Analytical Cookies</h3>
                        <p class="toggledesc {{fontData.name}}" [style.color]="themedata.color">
                            First-party analytics cookies are a type of cookie that collects data about how users
                            interact with our website. These cookies are used to analyse and measure various aspects of
                            website performance, such as the number of visitors, pages visited, time spent on each page,
                            and user engagement. These cookies do not gather data that can pinpoint a visitor's identity
                            at an individual level, as such information is not accessible to us. Additionally, these
                            cookies do not transmit personally identifiable information to any external third party,
                            except in specific instances where we enlist a service provider to assist us, under strict
                            conditions where they are unable to utilize the data for their own purposes.
                        </p>
                    </div>
                </div>
                <div class="d-flex jc-left">
                    <mat-slide-toggle class="" [color]="'primary'"
                        [(ngModel)]="isOtherCookiesAllowed"></mat-slide-toggle>
                    <div class="ml-1">
                        <h3 class="toggellabel" [style.color]="themedata.color">Functional Cookies</h3>
                        <p class="toggledesc {{fontData.name}}" [style.color]="themedata.color">
                            These cookies are used to enhance functionality and usability of the website for the users
                            and are considered essential for providing specific features and services requested by the
                            users. For example, functional cookies may remember a user's language preference, font size
                            selection, or region-specific settings, ensuring that the website is displayed according to
                            the user's preferences each time they visit. These cookies do not have the capability to
                            monitor your browsing activity on external websites. They do not collect any data about you
                            that could be utilized for advertising purposes or to recall your internet browsing history
                            beyond our website.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>

    <div class="d-flex jc-right my-2">
        <button class="modalbutton text-center {{fontData.name}}" (click)="saveCookieConsent()"
            [style.background-color]="themedata.primarytheme" [style.color]="themedata.cardtext">
            Save Settings
        </button>
    </div>
</section>